






















// @ is an alias to /src
import Vue from 'vue';
import ApiRequest from '@/util/apiRequest';
import TournamentInstance from '@/components/TournamentInstance.vue';

import { API_CATEGORY_QUERY, TITLE_TERMINATOR, API_TOURNAMENT_QUERY } from '@/util/config';

export default Vue.extend({
  name: 'tournament',
  data() {
    return {
      tournamentName: '',
      tournamentDescription: '',
      tournament: undefined,
    };
  },
  components: {
    TournamentInstance,
  },
  methods: {
    async load(nextRoute) {
      try {
        const response = await ApiRequest.Get(API_TOURNAMENT_QUERY + nextRoute.params.id);
        this.$data.tournamentName = response.name;
        document.title = response.name + TITLE_TERMINATOR;
        this.$data.tournamentDescription = response.description;
        this.$data.tournament = response;
      } catch (error) {
        if (error.statusCode === 404) {
          this.$data.tournamentName = 'Not Found';
        } else {
          throw error;
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.load(to);
    next();
  },
  mounted() {
    this.load(this.$route);
  },
});
